import { authEndpoints } from "@/constants";
import { axiosClient } from "@/services/axios-client";
import type { MessageResponseType, ResetPasswordRequestType } from "@/types";

export const resetPasswordHandler = async ({
    email,
    password,
    passwordConfirmation,
    token,
}: ResetPasswordRequestType): Promise<MessageResponseType> => {
    const response = await axiosClient.post<MessageResponseType>(
        authEndpoints.resetPassword,
        {
            email: email,
            password: password,
            password_confirmation: passwordConfirmation, // eslint-disable-line code-style/prop-naming-convention -- backend snake_case payload
            token: token,
        },
    );

    return { message: response.data.message };
};
